(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7227],{

/***/ 6046:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecommerce-seo-agency",
      function () {
        return __webpack_require__(4780);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var utils_animation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9428);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9472);
/* harmony import */ var components_blocks_hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6978);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9266);
/* harmony import */ var components_blocks_video_Video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2920);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4870);




// -------- custom component -------- //





var details = {
    pageName: "Ecommerce SEO Agency",
    categories: "seo, web design",
    description: "SEOptimist is an Ecommerce SEO Agency dedicated to improving your site ranking. Get your free technical SEO audit now from SEOptimist audit London",
    parentDirectories: ""
};
var mainPages = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "".concat(data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].url, "/").concat(data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(data_keywords__WEBPACK_IMPORTED_MODULE_7__.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                        className: "content-wrapper bg-white",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: (0,utils_animation__WEBPACK_IMPORTED_MODULE_8__/* .fadeInAnimate */ .St)("900ms"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_video_Video__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                    heading: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title,
                                    title1: "AI",
                                    title2: "SEO",
                                    title3: "",
                                    movie: "/1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: "helps London companies improve Google ranking with our free SEO audit. If\xa0you\xa0want to accelerate your business online, we are the experts using proprietary technology and AI."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-7 mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "Welcome to the world of SEOptimist, your",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_7__.CRO[0].title,
                                                        href: "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.CRO[0].url + "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.CRO[0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    ", where we are committed to elevating your e-commerce business to new heights. In this rapidly evolving digital age, establishing a strong online presence is paramount for the success of any e-commerce venture. With countless competitors vying for attention in the crowded digital marketplace, it's essential to find innovative ways to ensure that your brand not only stands out but also attracts the right customers. This is where our cutting-edge ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title,
                                                    ", SEOptimist, steps in. We specialize in providing tailored strategies and solutions designed to maximize your online visibility and drive targeted organic traffic to your website."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "At SEOptimist, we understand the unique challenges and opportunities that e-commerce businesses face. Our team of seasoned professionals has extensive experience in the e-commerce industry, and we have a deep understanding of the ever-changing landscape. We know what it takes to position your brand effectively, optimize your website for search engines, and attract high-quality organic traffic that converts into loyal customers."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "As an ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[0].title,
                                                    ", we offer a comprehensive range of services to meet your specific needs. From conducting in-depth keyword research and optimizing your website's on-page elements to creating engaging content and building high-quality backlinks, we leave no stone unturned in our quest to enhance your online visibility and drive growth. Our team utilizes advanced tools and industry-leading techniques to stay ahead of the curve and deliver outstanding results."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "One of the key pillars of our approach is our commitment to understanding your unique business goals and target audience. We believe that every e-commerce business is unique, and a one-size-fits-all approach simply won't cut it. That's why we take the time to get to know your business inside out, identifying your target market, understanding your brand's strengths and USPs, and developing customized strategies that align with your objectives."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Partnering with SEOptimist means gaining a strategic ally dedicated to your e-commerce success. We work hand in hand with you to develop and implement data-driven strategies that leverage the power of SEO to drive organic growth and improve your bottom line. Our team is continuously monitoring, analyzing, and optimizing your SEO campaigns to ensure that you stay ahead of the competition and adapt to the ever-changing digital landscape."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_hero__WEBPACK_IMPORTED_MODULE_3__/* .Hero1 */ .lE, {
                                bgcolor: "bg-soft-primary mb-20 pt-20",
                                title: "",
                                lead: "",
                                body: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-center",
                                        id: "report",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-center fs-34 mb-0 mx-auto",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                    children: [
                                                        "GET YOUR FREE ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "text-fuchsia",
                                                            children: "TECHNICAL SEO REPORT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-center fs-18 mx-auto",
                                                children: [
                                                    "Action the findings from the report or purchase ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.HomeList[8].title
                                                ]
                                            })
                                        ]
                                    }, 100)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-7 mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                children: [
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[1].title,
                                                    "s"
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "As ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[1].title,
                                                    "s, we recognize that every online store is unique, with its own set of goals, target audience, and industry dynamics. That's why our team of seasoned SEO experts takes a personalized approach, tailoring our strategies to align with your specific business objectives. Whether you're a startup looking to establish your digital presence or an established brand aiming to dominate your niche, we have the tools, techniques, and expertise to make it happen."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "With years of experience under our belt, we have developed a deep understanding of the intricacies of e-commerce SEO. We stay at the forefront of industry trends and algorithm updates, continuously refining our strategies to ensure maximum effectiveness. From conducting comprehensive keyword research and optimizing your website's structure and content to implementing technical SEO best practices and building authoritative backlinks, we leave no stone unturned in our pursuit of improving your online visibility and driving targeted organic traffic to your online store."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "What sets us apart as an ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[1].title,
                                                    " is our unwavering commitment to staying ahead of the curve. Our team is constantly monitoring and analyzing data, identifying emerging trends and opportunities, and adapting our strategies to ensure that you maintain a competitive edge. We utilize cutting-edge tools and advanced analytics to measure the effectiveness of our campaigns and make data-driven decisions that yield tangible results."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "At SEOptimist, we are more than just a service provider. We strive to be your trusted partner in navigating the complex world of e-commerce SEO. Our team takes the time to understand your unique business goals, target audience, and competitive landscape, enabling us to develop tailored strategies that deliver long-term success. We believe in fostering a collaborative relationship with our clients, providing transparent communication, regular progress reports, and dedicated support every step of the way."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[2].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "One of the key elements that set us apart from the competition is our deep understanding of e-commerce platforms. Whether you're operating on Shopify, WooCommerce, Magento, or any other popular platform, we have extensive experience in optimizing websites on these platforms. Our",
                                                    " ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[2].title,
                                                    "s will conduct a comprehensive audit of your website, identifying areas for improvement and developing a customized SEO plan to enhance your website's visibility in search engine results pages (SERPs). All along the process, you will be accompanied by a true",
                                                    " ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[2].title,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[3].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "SEOptimist is not just another ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[3].title,
                                                    ": we believe that SEO is not a one-size-fits-all solution. That's why we take a holistic approach to e-commerce SEO, considering every aspect that influences your website's performance. From on-page optimization, including keyword research and content optimization, to technical SEO elements like site structure and mobile optimization, we leave no stone unturned in our quest to boost your website's rankings. This is why we are a leading and successful ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[3].title,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "At SEOptimist, we pride ourselves on our comprehensive approach to ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title,
                                                    "s. We understand that a strong foundation is crucial for the success of any online store, and that's why we go beyond surface-level optimizations. Our team of highly skilled professionals possesses a deep understanding of the technical intricacies that can impact your website's search engine rankings."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "When it comes to ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title,
                                                    "s, we leave no stone unturned. Our experts utilize the latest industry tools and techniques to conduct in-depth keyword research, analyzing search volumes, competition, and search intent to identify high-value keywords that align with your specific business niche. These strategic keywords serve as the building blocks of your SEO strategy, allowing us to optimize your website's content, meta tags, and product descriptions to increase visibility and attract relevant organic traffic."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "But our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title,
                                                    " services don't stop there. We delve into the technical aspects of your website, analyzing its structure, crawlability, and indexability. Our team conducts a thorough review of your website's architecture, ensuring that it is optimized for search engine crawlers and that there are no technical barriers that hinder search engine bots from properly indexing your pages. We also assess your website's load speed, mobile responsiveness, and user experience, as these factors play a crucial role in both search engine rankings and user satisfaction."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "As a highly technical SEO agency, we employ a range of advanced tools and methodologies to conduct a comprehensive website SEO audit. We analyze your website's backlink profile, assessing the quality and relevance of your inbound links. We identify any potential issues that could be negatively impacting your search engine rankings and provide actionable recommendations to address them."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "At SEOptimist, we understand that an ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title,
                                                    " is not a one-time event, but rather an ongoing process. As part of our commitment to delivering sustainable results, we provide regular monitoring and reporting, allowing us to track the progress of your website's SEO performance and make data-driven decisions to continually improve its visibility and organic rankings."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "By partnering with SEOptimist for your ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[4].title,
                                                    ", you can rest assured that you are receiving highly qualitative and customized services. SEOptimist is a deeply",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_7__.HomeList[0].title,
                                                        href: "/"
                                                    }),
                                                    " that provides highly qualitative",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[1].title,
                                                        href: "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[0].url + "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    ". Our team of experts combines technical expertise, industry knowledge, and a data-driven approach to provide you with an in-depth understanding of your website's SEO performance and actionable insights to drive growth."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[5].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "In addition to on-page optimization, our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[5].title,
                                                    " team is well-versed in off-page SEO strategies that build your website's authority and credibility. We employ ethical and white-hat link building techniques to acquire high-quality backlinks from reputable websites in your industry. SEOptimist will act as your personal ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[5].title,
                                                    " by establishing a robust network of backlinks, giving your website credibility in the eyes of search engines, which can significantly improve your rankings and organic traffic over time."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "At SEOptimist, we go above and beyond to provide you with comprehensive and customizable",
                                                    " ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title,
                                                    " that cater to the unique needs and goals of your online business. We understand that every e-commerce website is different, and that's why we offer a range of packages designed to meet your specific requirements."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Our team of experienced SEO professionals is dedicated to staying ahead of the curve in the ever-evolving world of search engine optimization. We closely monitor the latest algorithm updates, industry trends, and emerging technologies to ensure that your e-commerce website remains optimized for search engines' evolving requirements. By staying on top of the latest SEO best practices, we can adapt our strategies to keep your business ahead of the competition."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "When it comes to our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title,
                                                    ", we offer a variety of services that can give your online store the competitive edge it needs. Whether it's optimizing your website for voice search to capture the growing number of voice-enabled device users, leveraging structured data markup to enhance the visibility and appeal of your product listings in search results, or implementing schema markup to provide search engines with more context about your products, we have the expertise to implement these advanced techniques."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "Our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title,
                                                    " are tailored to suit businesses of all sizes and budgets. We understand that your goals and priorities may vary, and that's why we offer flexibility in our packages. Whether you're looking for a comprehensive SEO overhaul or specific targeted optimizations, we can create a package that aligns with your requirements and delivers tangible results."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "By choosing one of our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title,
                                                    ", you can expect a strategic and data-driven approach to optimizing your online store. Our team will conduct in-depth keyword research, analyze your competitors, and perform a thorough audit of your website to identify areas for improvement. We will then develop a tailored SEO strategy that focuses on increasing your website's visibility, driving relevant organic traffic, and ultimately boosting your conversions and revenue."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "With our ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[6].title,
                                                    ", you can have peace of mind knowing that your online business is in the hands of experts who are dedicated to your success. We will provide you with regular reports and transparent communication, keeping you informed of the progress and results of our SEO efforts. Our team is always available to answer any questions, address any concerns, and provide ongoing support as your business continues to grow."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                children: data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[7].title
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "When you partner with SEOptimist, you gain more than just an ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[7].title,
                                                    ". You gain a dedicated team of professionals who are committed to your success. We take the time to understand your business objectives, target audience, and competitive landscape, allowing us to create a tailored SEO strategy that aligns with your unique needs. Our transparent reporting and regular communication keep you informed of the progress we're making, ensuring that you always have a clear picture of how our efforts are driving results for your e-commerce business. Choosing SEOptimist is choosing a leading and trusted ",
                                                    data_keywords__WEBPACK_IMPORTED_MODULE_7__.EcommerceSEO[7].title,
                                                    ". Don't let your e-commerce website get lost in the vast sea of competitors. Get to know our",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[1].title,
                                                        href: "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[0].url + "/" + data_keywords__WEBPACK_IMPORTED_MODULE_7__.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")
                                                    }),
                                                    ". Take charge of your online presence with SEOptimist. Contact us today to discuss your business goals and let our team of experts devise a comprehensive SEO strategy that propels your e-commerce business to new heights of success. Together, we can unlock the full potential of your online store and drive sustainable growth in the ever-competitive e-commerce landscape."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (mainPages);


/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9472);




var GoogleAppBtn = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex justify-content-center justify-content-lg-start",
        style: slideInDownAnimate("900ms"),
        children: [
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1200ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-primary btn-icon btn-icon-start rounded me-2",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-apple"
                            }),
                            " App Store"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1500ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-green btn-icon btn-icon-start rounded",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-google-play"
                            }),
                            " Google Play"
                        ]
                    })
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (GoogleAppBtn)));


/***/ }),

/***/ 7632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6523);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2546);







// ==================================================================
var Carousel = function(props) {
    var children = props.children, slideClassName = props.slideClassName, _spaceBetween = props.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 30 : _spaceBetween, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 3 : _slidesPerView, _pagination = props.pagination, pagination = _pagination === void 0 ? true : _pagination, _navigation = props.navigation, navigation = _navigation === void 0 ? true : _navigation, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "slideClassName",
        "spaceBetween",
        "slidesPerView",
        "pagination",
        "navigation"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref[0], setPrevEl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
        ],
        navigation: navigation ? {
            prevEl: prevEl,
            nextEl: nextEl
        } : false,
        pagination: pagination ? {
            clickable: true
        } : false
    }, others), {
        children: [
            children.map(function(slide, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                    className: slideClassName,
                    children: slide
                }, i);
            }),
            navigation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "swiper-navigation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setPrevEl(node);
                        },
                        className: "swiper-button swiper-button-prev swiper-button-disabled"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setNextEl(node);
                        },
                        className: "swiper-button swiper-button-next"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 2744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);





// ====================================================
var FigureImage = function(props) {
    var className = props.className, src = props.src, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "src",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className
    }, others), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            width: width,
            height: height,
            src: src,
            alt: "demo",
            quality: "100"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FigureImage);


/***/ }),

/***/ 9486:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useLightBox = function() {
    var lightboxLoad = function() {
        var GLightbox = __webpack_require__(7727);
        GLightbox({
            loop: false,
            moreLength: 0,
            zoomable: false,
            autoplayVideos: true,
            touchNavigation: true,
            selector: "*[data-glightbox]",
            // slideExtraAttributes: { poster: '' },
            plyr: {
                config: {
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            }
        });
    };
    useEffect(function() {
        lightboxLoad();
    }, []);
    return null;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useLightBox)));


/***/ }),

/***/ 9588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
// useLogVisitor.js


var useLogVisitor = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visitor = Array.isArray(router.query.visitor) ? router.query.visitor[0] : router.query.visitor;
        if (visitor) {
            fetch("/api/log-visitor/?visitor=".concat(encodeURIComponent(visitor))).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log("Visitor logged:", data.message);
            }).catch(function(error) {
                console.error("Error logging visitor:", error);
            });
        }
    }, [
        router.query.visitor
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogVisitor);


/***/ }),

/***/ 9:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Check = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 409.6 409.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-primary mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 409.6C91.9 409.6 0 317.7 0 204.8c0-49.9 18.2-98.1 51.2-135.5 4.4-5 12-5.5 17-1.1s5.5 12 1.1 17c-29.1 33-45.2 75.5-45.2 119.5 0 99.6 81.1 180.7 180.7 180.7s180.7-81.1 180.7-180.7S304.4 24.1 204.8 24.1c-27.3-.1-54.2 6.1-78.7 18-6 2.9-13.2.4-16.1-5.6-2.9-6-.4-13.2 5.6-16.1C143.4 6.9 173.9-.1 204.8 0c112.9 0 204.8 91.9 204.8 204.8s-91.9 204.8-204.8 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M349.4 204.8c0 79.8-64.7 144.6-144.6 144.6S60.2 284.6 60.2 204.8 125 60.2 204.8 60.2 349.4 125 349.4 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 361.4c-86.4 0-156.6-70.2-156.6-156.6S118.4 48.2 204.8 48.2s156.6 70.2 156.6 156.6-70.2 156.6-156.6 156.6zm0-289.1c-73.1 0-132.5 59.4-132.5 132.5s59.4 132.5 132.5 132.5 132.5-59.5 132.5-132.5S277.9 72.3 204.8 72.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M200.9 246.7c-8.8 0-17.2-3.5-23.5-9.7L145 204.5c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l32.5 32.5c3.6 3.5 9.3 3.5 12.8 0l49.8-49.9c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17L224.4 237c-6.2 6.2-14.7 9.7-23.5 9.7z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,7857,7727,4090,4870,4556,4992,9774,2888,179], function() { return __webpack_exec__(6046); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);